import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { SelectOptionProps } from '../../SelectOption.types';

type Props = Pick<SelectOptionProps, 'menuPlacement'>;

export const useStyles = ({ menuPlacement }: Props) => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.tertiary,
        padding: theme.spacing.secondary,
        paddingTop: menuPlacement === 'bottom' ? 0 : theme.spacing.secondary,
        paddingBottom: menuPlacement === 'bottom' ? theme.spacing.secondary : 0,
        maxHeight: '170px',
      },
    }),
    [],
  );

  return styles;
};
